import { Component, ViewEncapsulation } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'ui-nav-list',
  templateUrl: './nav-list.component.html',
  styleUrl: './nav-list.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatCardModule],
})
export class NavListComponent {}
